import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import { FormFieldProps } from '../../../../infrastructure/form-viewmodel-controller';

interface IProps {
    field: FormFieldProps;
    labelDescriptor: MessageDescriptor;
}

export const FormFieldError = observer(({ field, labelDescriptor }: IProps): JSX.Element => {
    const intl = useIntl();

    return (
        <span className='oe-form-field__error'>
            {
                !field.valid && field.touched &&
                <FormattedMessage
                    values={{ fieldName: intl.formatMessage(labelDescriptor) }}
                    {...field.validationMessage}
                />
            }
        </span>
    );
});
